import { render, staticRenderFns } from "./TablePrivate.vue?vue&type=template&id=403ea1b3"
import script from "./TablePrivate.vue?vue&type=script&lang=js"
export * from "./TablePrivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports